import webpack from "webpack"
import path from "path"
// import colors from "chalk"
// import { spawn } from "child_process"
import security from "./security"
import { thereIsAnyFileMatching, killProcessTree } from './utils'
import getWebpackConfig  from "./app.wp-config"
import buildRunner from './build-runner.js'
import { Spinner } from 'cli-spinner'
import { ensureExists, FURTHER_PATH, FURTHER_REF } from './utils'
import httpServer from './http-server'
import fs from 'fs-extra'
import { /* clearTerminal, */ moveTo, statusLine } from './terminal-utils'
import inspector from 'inspector'
// import tryRequire from 'try-require'
const _DEPS = require('./technologies/deps')
import { ensureInstallation } from './npm-dyn-dependencies'

const DEFAULT_REPORTS = {
    verbosity: 0,
    unusedDeps: true,
    outdatedDeps: true,
    security: {}
}
const DEFAULT_OPTIONS = {
    installing: {},
    development: {
        autoCreateFiles: 'interactive'
    },
    production: {}
}

const DEFAULT_DIST_PATH = 'dist'
const DEFAULT_SRC_PATH = 'src'
const spinner = new Spinner('%s Starting up...')
spinner.setSpinnerString('⠉⠑⠡⢁⡁⡈⠌⠊') // '◷◶◵◴'

function watchForConfigChanges (that) {

    let configChokidar = require('chokidar')
    if (configChokidar.watch) {
        configChokidar = configChokidar.watch(
            path.resolve(that.paths.src, '../index.js')
        )

        configChokidar.on('change', _ => {
            console.log(statusLine('important',
                'Detected change in configuration.\n' +
                'Requires a restart to load the new settings.\n' +
                'Exiting build process with code 999'
            ))
            
            process.exit(999)
        })
    }
}

export default class App {
    
    constructor () {
        this.hasEnsuredBasicDeps = false
    }

    async ensureDeps () {
        // console.log('>>> InstRef:', FURTHER_PATH)
        await ensureInstallation('babel', null,
        {
            verbose: true,
            node_modules: FURTHER_PATH,
            installing: this.opts.installing
        })
        this.hasEnsuredBasicDeps = true
    }

    async config (config) {

        if (!this.hasEnsuredBasicDeps) {
            await this.ensureDeps()
        }

        const PROJECT_PATH = path.resolve(path.dirname(process.argv[1]))
        const OUTPUT_PATH = path.resolve(PROJECT_PATH, config.outputPath || DEFAULT_DIST_PATH)
        const SRC_PATH = path.resolve(PROJECT_PATH, config.src || DEFAULT_SRC_PATH)
        // const FURTHER_PATH = furtherInstallationPath || process.cwd()

        this.paths = {
            project: PROJECT_PATH,
            dist: OUTPUT_PATH,
            src: SRC_PATH,
            further: FURTHER_PATH,
            furtherRef: FURTHER_REF,
            usedExtensions: new Set(await thereIsAnyFileMatching(SRC_PATH, [
                '.js',
                '.css',
                '.jsx',
                '.vue',
                '.ts',
                '.tsx',
                '.scss',
                '.less',
                '.styl',
                '.coffee'
            ]))
        }
        
        // storing the current package.json configuration for the project
        this.pkg = JSON.parse(await fs.readFile(path.resolve(this.paths.project, 'package.json')))

        // we should give the exit signals a better treatment
        process.on('SIGINT', event => { process.exit(0)} )
        process.on('SIGTERM', event => { process.exit(0)} )
        process.on('SIGUSR1', event => { process.exit(0)} )
        process.on('SIGUSR2', event => { process.exit(0)} )
        process.on('beforeExit', async event => {})
        process.on('exit', code => {
            inspector.close()
            console.log(
                '\nThanks for using furtherjs.\n' +
                'Please report any issue at nasc\'s repository')
            process.exit(code)
        })
        // process.on('uncaughtException', event => {process.exit(0)})

        this.settings = this.settings || config || {}
        return this.reloadWebpackSettings()
    }

    reloadWebpackSettings () {
        let ret = getWebpackConfig(this.settings, this.paths, this).then((wpConfig) => {
            this.settings.webpackConfig = wpConfig
        })
        ret.start = this.start
        return ret
    }

    async onBuildDone (buildType, data = {}, stats) {

        if (this.settings.mode === 'dev') {
            // we will generate the reports, but will
            // not wait for them
            security.check(this)
        }

        if (buildType === 'client') {
        }

        let httpPid = 0
        if (buildType === 'server') {
            let opts = this.opts || {}
            if (opts.server !== false) {
                try {
                    httpPid = await httpServer.start({
                        compiler: this.compiler,
                        opts: this.opts,
                        config: this.config,
                        paths: this.paths,
                        stats
                    })
                    this.httpPid = httpPid
                } catch (e) {
                    if (opts.breakpointOnErrors) {
                        debugger
                    }
                    stats.compilation.errors.push({
                        name: 'Server startup error',
                        message: `Could not start HTTP Server.\n${e.message || e}`
                    })
                }
            }

            // let loadServer = require(this.paths.further + "/bundle-loader!" + serverPath)
            // let loadServer = bundleLoader(serverPath)
            // loadServer(result => {
            //     debugger
            // })
            // let serv = require(serverPath, res => {
            //     debugger
            // }, err => {
            //     debugger
            // })
            // debugger
            // console.log(serv)
            // let req = require.context(serverPath, false, /index\.js$/)
            // let serv = req([serverPath + 'index.js'], data => {debugger})
            // function importAll (r) {
            //     r.keys().forEach(r);
            //   }
               
            //   importAll(require.context(serverPath, false, /index\.js$/))
              
            // return
            // SERVER_CONFIG.plugins.push(new WebpackOnBuildPlugin(async function(stats) {
            //     // unless the user has disabled it, we start an HTTP Server
            //     debugger
            // }))
        }
    }

    startWatcher (emptyBuild = false) {
        if (this.compilerWatcher) {
            // it is already watching
            return
        }
        watchForConfigChanges(this)
        this.compilerWatcher = this.compiler.watch(
            this.listForTheCompilerToWatch,
            buildRunner.bind(this)
        )

        if (emptyBuild) {
            buildRunner.call(this, {})
        }
        return this
    }

    async reset () {
        const that = this
        return new Promise((resolve, reject) => {
            // stop watching changes
            that.compilerWatcher.close()
            that.compilerWatcher = false
            // if it was debugging, we set it to false anyway
            that.opts.debug = false
            // get the configuration again
            // (this time, with the newly installed dependencies)

            that.config(that.opts).then(_ => {
                // restart the compiler and watcher

                that.compiler = webpack(that.settings.webpackConfig)
                that.startWatcher()
                resolve()
            })
        })
    }

    start (opts) {
        this.opts = opts || this.opts || {}
        this.opts = Object.assign({}, DEFAULT_OPTIONS, this.opts)
        this.opts.reports = Object.assign({}, this.opts.reports || {}, DEFAULT_REPORTS)
        const that = this
        this.spinner = spinner

        this.config(opts).then(_ => {
            spinner.start()
            const config = this.settings
            spinner.setSpinnerTitle('Instantiating webpack')
            // generate the compiler based on the new settings
            // const compiler = webpack(this.settings.webpackConfig)
            that.compiler = webpack(this.settings.webpackConfig)
            console.log('\n')

            if (config.mode === 'dev') {
                // if in devMode, we start watching for changes
                spinner.setSpinnerTitle('Entering developer mode... ')
                // move cursor to begining of line in terminal
                moveTo('lineStart')
                // we use chokidar to watch for new files in runtime
                const chokidar = require('chokidar')

                if (opts.server) {
                    fs.ensureDirSync(path.join(that.paths.src, 'server/main'))
                    fs.ensureFileSync(path.join(that.paths.src, 'server/services/.gitkeep'))
                    fs.ensureFileSync(path.join(that.paths.src, 'server/statuses/403.html'))
                    fs.ensureFileSync(path.join(that.paths.src, 'server/statuses/404.html'))
                    fs.ensureFileSync(path.join(that.paths.src, 'server/statuses/500.html'))
                    ensureExists(path.join(that.paths.src, 'server/main/index.js'), 11)
                }
                if (opts.client) {
                    fs.ensureFileSync(path.join(that.paths.src, 'client/components/.gitkeep'))
                    ensureExists(path.join(that.paths.src, 'client/main/index.js'), 11)
                    ensureExists(path.join(that.paths.src, 'client/main/templates/index.html'), 11)
                }
                if (opts.cli) {
                    fs.ensureDirSync(path.join(that.paths.src, 'cli/main'))
                    fs.ensureFileSync(path.join(that.paths.src, 'cli/commands/.gitkeep'))
                    ensureExists(path.join(that.paths.src, 'cli/main/index.js'), 11)
                }
                fs.ensureFile(path.join(that.paths.project, 'PULL_REQUEST_TEMPLATE.md'))
                fs.ensureFile(path.join(that.paths.project, 'ISSUE_TEMPLATE.md'))
                fs.ensureFile(path.join(that.paths.project, 'CODE_OF_CONDUCT.md'))

                const chokidatWatcher = chokidar.watch(that.paths.src,
                    Object.assign(
                        {},
                        config.watchOptions || {},
                        {
                            ignored: /((^|[\/\\])\..\/)|(node_modules|dist\/)|(\.git)|(.DS_Store)|(\.tmp)|(\.further)|(~.+)|(README)|(readme)/
                        }
                    )
                )

                let isReady = false
                this.listForTheCompilerToWatch = []
                let nothingToWatchYet = true

                chokidatWatcher.on('add', async fullPath => {
                    nothingToWatchYet = false
                    // any file chokidar adds, will be unwatched by chokidar
                    // and will begin to be watched by the compiler's watcher
                    chokidatWatcher.unwatch(fullPath)
                    if (isReady) {
                        // if the first build has already happened, we have to
                        // rebuild, adding it to the wp compiler's watcher
                        if (!that.paths.usedExtensions.has(path.extname(fullPath))) {
                            // new kind of file (an extension that had not been used yet)
                            // let's see if we need to install it
                            let depsGroup = _DEPS.dependencyExts[path.extname(fullPath)]

                            // try and install it
                            let hadToInstall = await ensureInstallation(depsGroup, null,
                                {
                                  verbose: true,
                                //   node_modules: that.paths.further + '/node_modules/furtherjs/node_modules/'
                                }
                            )

                            if (hadToInstall) {
                                // if we had to install something new, we will
                                // have to stop the watcher, re-create the compiler
                                // reload its settings and then restart the watch task
                                await that.reset()
                            }
                        }

                        // and now, we are ready to run the compiler task
                        that.compiler.run(_=>{
                            buildRunner.bind(that)
                        })
                    } else {
                        // first build in proccess, let's add it to the list
                        this.listForTheCompilerToWatch.push(fullPath)
                    }
                })

                chokidatWatcher.on('ready', _ => {
                    // we will use the webpakc compiler's watch to watch the files
                    // after the first build. This way, new builds get a little optimized
                    isReady = true
                    if (!this.listForTheCompilerToWatch.length) {
                        console.log('Nothing to watch. Waiting for new files')
                        spinner.stop()
                    }
                    that.startWatcher()
                })

                // if no file has been seen in 1sec, we build it empty
                setTimeout(_ => {
                    if (nothingToWatchYet) {
                        that.startWatcher(true)
                    }
                }, 1000)
            } else {
                spinner.setSpinnerTitle('Entering production mode... ')
                // move cursor to begining of line in terminal
                moveTo('lineStart')
                // if not in devMode, we simply run/start it
                that.compiler.run(buildRunner.bind(that))
            }
        })
    }
}



// WEBPACK FOOTER //
// ./src/app.class.js